import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useSwipeable } from "react-swipeable";

/** Notification Component */
const Notification = ({ type, title, description, onClose }) => {
	const [translate, setTranslate] = useState(0);

	const swipingHandlers = useSwipeable({
		onSwipedUp: (eventData) => {
			if (eventData.absY >= 30) {
				onClose && onClose();
			} else {
				setTranslate(0);
			}
		},
		onSwipedDown: (eventData) => {
			setTranslate(0);
		},
		onSwiping: (eventData) => {
			if (eventData.absY >= 30) {
				onClose && onClose();
			} else {
				setTranslate(eventData.absY);
			}
		},
		delta: 1
	});

	useEffect(() => {
		setTimeout(() => {
			onClose && onClose();
		}, 3000);
	}, []);

	return (
		<div
			className={"vs--notification-modal vs--flex vs--align-center vs--pt-10 vs--pb-10 vs--pr-10 vs--notification-modal-" + type}
			style={{
				transform: `translateY(-${translate}px)`
			}}
			{...swipingHandlers}
		>
			<div className="vs--notification-modal-icon vs--flex vs--align-center vs--justify-center vs--pl-10 vs--pr-10">{type === "success" ? <i className="ic_done vs--font-bigest" /> : null}</div>

			<div className="vs--notification-modal-content vs--flex-equal vs--pb-8 vs--pt-8">
				<span className="vs--notification-modal-title vs--title-white vs--font-normal vs--font-medium vs--mb-2">{title}</span>
				<span className="vs--notification-modal-description vs--title-white vs--font-small vs--font-regular">{description}</span>
			</div>
		</div>
	);
};

/** Notification propTypes
 * PropTypes
 */
Notification.propTypes = {
	/** Notification type */
	type: PropTypes.oneOf(["success", "info", "error"]),
	/** Notification title */
	title: PropTypes.string,
	/** Notification description */
	description: PropTypes.string,
	/** Function to call on notification close */
	onClose: PropTypes.func
};

export default Notification;
